<p-card>
   <form #searchForm="ngForm" name="searchForm" id="searchForm" style="width:100%" requiredAtleastOnefield>
      <div class="row m-1">
         <div class="row col-lg-12 mt-2">
            <div class="col-lg-6">
               <div class="row">
                  <div class="col-lg-6 font-weight-bold">
                     <label name="NamedInsured" id="NamedInsured">Named Insured:</label>
                  </div>
                  <div class="col-lg-6">
                     <input [(ngModel)]="workInProgressSearchModal.namedInsured" type="text" class="form-control"
                        placeholder="Named Insured" name="nameInsured" id="NamedInsured" #nameInsured="ngModel"
                        [maxlength]="100">
                  </div>
               </div>
            </div>
            <div *ngIf="!isEndorsementView" class="col-lg-6">
               <div class="row">
                  <div class="col-lg-6 font-weight-bold">
                     <label name="searchdotlabel" id="searchdotlabel">DOT#:</label>
                  </div>
                  <div class="col-lg-6">
                     <input [(ngModel)]="workInProgressSearchModal.dot" type="text" class="form-control"
                        placeholder="DOT#" name="searchdot" id="searchdot" #searchdot="ngModel"
                        numbersOnly (keypress)="numbersOnly($event)" maxlength="8">
                        <div class="row mt-1" *ngIf="searchdot.invalid && searchdot.dirty">
                           <div class="col">
                             <span class="validationred">Only numbers are allowed.</span>
                           </div>
                        </div>
                  </div>
               </div>
            </div>
            <div *ngIf="isEndorsementView" class="col-lg-6">
               <div class="row">
                  <div class="col-lg-6 font-weight-bold">
                     <label name="searchPolicylabel" id="searchPolicylabel">Policy#:</label>
                  </div>
                  <div class="col-lg-6">
                     <input [(ngModel)]="workInProgressSearchModal.policyNumber" type="text" class="form-control"
                        placeholder="Policy Number" name="searchPolicy" id="searchPolicy" #searchPolicy="ngModel"
                        (keypress)="numbersOnly($event)"
                        pasteNumbersOnly
                        maxlength="7"
                        minlength="7"
                     >                        
                        <div class="row mt-1" *ngIf="isSubmitted && searchPolicy.invalid">
                           <div class="col">
                             <span class="validationred">Please enter a valid Policy number using numeric values only.</span>
                           </div>
                        </div>
                  </div>
               </div>
            </div>
            <div *ngIf="!isEndorsementView" class="col-lg-6 mt-3">
               <div class="row">
                  <div class="col-lg-6 font-weight-bold">
                     <label name="BegEffectiveDateLabel" id="BegEffectiveDateLabel">Beginning Effective Date:</label>
                  </div>
                  <div class="col-lg-6">
                     <p-datepicker dateFormat="mm/dd/yy" [showIcon]="true" type="text" inputId="calendarIcon1"
                        id="BegEffectiveDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2050"
                        placeholder="MM / DD / YYYY" [(ngModel)]="workInProgressSearchModal.beginningEffectiveDate"
                        name="BegEffectiveDate" #BegEffectiveDateID="ngModel"
                        [maxDate]="workInProgressSearchModal.endingEffectiveDate"></p-datepicker>
                  </div>
               </div>
            </div>
            <div *ngIf="isEndorsementView" class="col-lg-6 mt-3">
               <div class="row">
                  <div class="col-lg-6 font-weight-bold" [class.pr-0]="isEndorsementView">
                     <label name="EndorseEffectiveDateLabel" id="EndorseEffectiveDateLabel">Endorsement Effective
                        Date:</label>
                  </div>
                  <div class="col-lg-6">
                     <p-datepicker dataType="string" dateFormat="mm/dd/yy" [showIcon]="true" type="text"
                        inputId="endorsementCalendarIcon" id="EndorseEffectiveDate" [monthNavigator]="true"
                        [yearNavigator]="true" yearRange="1900:2050" placeholder="MM / DD / YYYY"
                        [(ngModel)]="workInProgressSearchModal.endorsementEffectiveDate" name="EndorseEffectiveDate"
                        #EndorseEffectiveDateID="ngModel"></p-datepicker>
                  </div>
               </div>
            </div>
            <div *ngIf="!isEndorsementView" class="col-lg-6 mt-3">
               <div class="row">
                  <div class="col-lg-6 font-weight-bold">
                     <label name="endingEffectiveDateLabel" id="endingEffectiveDateLabel">Ending Effective
                        Date:</label>
                  </div>
                  <div class="col-lg-6">
                     <p-datepicker dateFormat="mm/dd/yy" [showIcon]="true" inputId="calendarIcon2"
                        id="endingEffectiveDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2050"
                        placeholder="MM / DD / YYYY" [(ngModel)]="workInProgressSearchModal.endingEffectiveDate"
                        name="endingEffectiveDate" #endingEffectiveDate="ngModel"
                        [minDate]="workInProgressSearchModal.beginningEffectiveDate"></p-datepicker>
                  </div>
               </div>
            </div>
            <div class="col-lg-6 mt-3">
               <div class="row">
                  <div class="col-lg-6 font-weight-bold">
                     <label name="Status" id="Status">Status:</label>
                  </div>
                  <div class="col-lg-6">
                     <p-select [options]="workInProgressStatusDropdown" [(ngModel)]="workInProgressSearchModal.status"
                        name="Status" id="Status" #Status="ngModel" placeholder="Status"></p-select>
                  </div>
               </div>
            </div>
            <div class="col-lg-6 mt-3 text-right" [class.col-lg-12]="isEndorsementView">
               <button class="btnsuccess mr-2" title="Search" name="Search" id="search" data-toggle="modal"
                  (click)="getWIPFilter(searchForm)" type="submit">
                  <i class="fa fa-search" aria-hidden="true"></i> Search
               </button>
               <button class="btnsuccess" title="Reset" name="reset" id="reset" data-toggle="modal"
                  (click)="resetWIPFilter(searchForm)" type="submit">
                  <i class="fa fa-refresh" aria-hidden="true"></i> Reset
               </button>
            </div>
         </div>
      </div>
      <div class="row float-right" *ngIf="isSubmitted && searchForm.errors?.requiredAtleastOnefield">
         <div class="row mr-2">
            <span class="validationred">At-least one search criteria is required</span>
         </div>
      </div>
      <div class="row float-right" *ngIf="isSubmitted && hasNoWorkInProgressResults && !isFormChanged">
         <div class="row mr-2">
            <span class="color_maroon">No record found matching the search criteria</span>
         </div>
      </div>
   </form>
</p-card>
<div *ngIf="!!workInProgressData && workInProgressData.length > 0">
   <div class="table-responsive mt-2">
      <div class="row" style="margin-right: 5px; justify-content: right; display: flex; align-items: center;">
         <span class="search-container">
            <i class="pi pi-search search-icon"></i>
               <input pInputText type="text" class="search-input"
                  (input)="dt1.filterGlobal($event.target.value, 'contains')" placeholder="Search in table" />
         </span>
      </div>
      <p-table class="table llh_table p-datatable-striped" [class.endorsement]="isEndorsementView"
         [class.agencyView]="isAgencyView" styleClass="p-datatable-striped" [rows]="10" [value]="workInProgressData"
         [paginator]="true" [customSort]="true" (sortFunction)="customSort($event)" #dt1
         [globalFilterFields]="['nameInsured', 'dotNumber', 'policyNumber', 'accountState', 'effectiveDate', 'status', 'tags', 'agentName', 'submissionTimeStamp']">
         <ng-template pTemplate="header">
            <tr>
               <th pSortableColumn="nameInsured" class="namedInsured">Named Insured</th>
               <th pSortableColumn="dotNumber" *ngIf="!isEndorsementView" style="width: 10%;">DOT#</th>
               <th pSortableColumn="policyNumber" *ngIf="isEndorsementView" style="width: 12%;">Policy#</th>
               <th pSortableColumn="accountState" class="text-center" *ngIf="!isEndorsementView">State</th>
               <th pSortableColumn="effectiveDate" class="effectiveDate text-center">
                  {{isEndorsementView ? 'Endorsement Effective Date' : 'Effective Date'}}</th>
               <th pSortableColumn="status" class="status">Status</th>
               <th pSortableColumn="agentName" class="agentName" *ngIf="isAgencyView || isEndorsementView">Agent Name</th>
               <th pSortableColumn="submissionTimeStamp" class="submittedOn">
                  {{isEndorsementView ? 'Submitted On (EST)' : 'Last Modified Timestamp (EST)'}}</th>
               <th pSortableColumn="action" class="action" *ngIf="!isEndorsementView && (!isAgencyView || (isAgencyView && !!auth0UserService?.auth0User.isAdmin))">Action</th> 
            </tr>
         </ng-template>
         <ng-template let-item let-i=rowIndex pTemplate="body">
            <tr [pSelectableRow]="item">
               <td title="{{item?.nameInsured}}">{{item?.nameInsured}}</td>
               <td *ngIf="!isEndorsementView" [class.wiplink]="item?.status == 'Incomplete' || item?.status == 'Indication'" name="grdDot" id="grdDot"
                  title="{{item?.dotNumber}}">
                  <span (click)="onRowSelect(item)" [attr.tabindex]="item?.status === 'Incomplete' || item?.status === 'Indication' ? 0 : null"
                        (keydown.space)="$event.preventDefault(); onRowSelect(item);">{{item?.dotNumber}}</span>
               </td>
               <td *ngIf="isEndorsementView"  [class.wiplink]="item.status == 'Incomplete'" title="{{item?.policyNumber}}">
                  <span (click)="clickedInProgressEndorsement(item)" [attr.tabindex]="item?.status === 'Incomplete' ? 0 : null"
                     (keydown.space)="$event.preventDefault(); clickedInProgressEndorsement(item);">{{item?.policyNumber}}</span></td>
               <td class="text-center" *ngIf="!isEndorsementView">{{item?.accountState}}</td>
               <td class="text-center" title="{{item?.effectiveDate}}">{{item?.effectiveDate}}</td>
               <td title="{{!!item?.declineReason ? item?.declineReason : item?.status}}">
                  {{item?.status == 'Indication' ? 'No formal Quote Requested' : item?.status}}
               </td>
               <td *ngIf="isAgencyView || isEndorsementView" title="{{item?.agentName}}">{{item?.agentName}}</td>
               <td title="{{ (isEndorsementView ? item?.submissionTimeStamp : item?.modifiedDateTime) | date: 'MM/dd/yyyy hh:mm:ss a'}}">
                  {{ (isEndorsementView ? item?.submissionTimeStamp : item?.modifiedDateTime) | date: 'MM/dd/yyyy hh:mm:ss a'}}
               </td>
               <td style="text-align: center;" title="Reassign submission to another user" *ngIf="!isEndorsementView && (!isAgencyView || (isAgencyView && !!auth0UserService?.auth0User.isAdmin))">
                  <span *ngIf="(item.status == 'Incomplete' || item.status == 'Indication')">
                     <i class="pi pi-user-edit deleteUserbtn-blue" (click)="popUpReassignDialog(item)" tabindex="0"
                        (keydown.space)="$event.preventDefault(); popUpReassignDialog(item)"></i>
                  </span>
               </td>
            </tr>
         </ng-template>
      </p-table>
   </div>
   <p-dialog header="" [(visible)]="agentListService.shallDiplayReassignDialog"
        (onHide)="closeReassignDialog()" class="dialog_bulk_edit edit-user-popup" [modal]="true">
        <div class="row">
            <div class="col-lg-12 editUser">
                <nfp-reassign-submission></nfp-reassign-submission>
            </div>
        </div>
    </p-dialog>
</div>